import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput, StrengthRules } from "@/components/auth/PasswordInput";
import { api, errMsg } from "@/lib/api";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const empty = { current_password: "", new_password: "", confirm_password: "" };
  const [f, setF] = useState(empty);
  const submit = async () => {
    try {
      await api.post("/auth/change-password", f);
      toast.success("Mot de passe modifié — un e-mail de confirmation vous a été envoyé");
      setF(empty);
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Changer mon mot de passe</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Mot de passe actuel</Label>
            <PasswordInput value={f.current_password} testId="current-password-input"
              onChange={(e) => setF({ ...f, current_password: e.target.value })} />
          </div>
          <div>
            <Label>Nouveau mot de passe</Label>
            <PasswordInput value={f.new_password} testId="new-password-input"
              onChange={(e) => setF({ ...f, new_password: e.target.value })} />
            <StrengthRules value={f.new_password} />
          </div>
          <div>
            <Label>Confirmer le nouveau mot de passe</Label>
            <PasswordInput value={f.confirm_password} testId="confirm-password-input"
              onChange={(e) => setF({ ...f, confirm_password: e.target.value })} />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={submit} data-testid="change-password-submit">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
